import { Injectable } from '@angular/core';
import { DataService } from '../data.service';
import { BillingInvoiceAmount } from 'src/app/model/billing/billing-invoice-amount';
import { ClientFilter } from '../../model/client-filter';
import { BillingInvoiceItemEditInfo } from '../../model/billing/billing-invoice-item-edit-info';
import { ClientSearch } from '../../model/client-search';
import { InvoicePoint } from '../../model/invoice-point';

@Injectable({
  providedIn: 'root'
})
export class BillingInvoiceAmountService {

  constructor( private dataService: DataService ) {
  }

  private readonly calculateBillingInvoiceAmountEndPoint: string =
    '/billingInvoiceAmount/calculateBillingInvoiceAmount/';

  async calculateBillingInvoiceAmount(
      client: ClientSearch,
      invoicePoint: InvoicePoint,
      items: BillingInvoiceItemEditInfo[] ): Promise<BillingInvoiceAmount> {

    const params = { Client: client, Items: items, InvoicePoint: invoicePoint };

    return await this.dataService
                     .post<BillingInvoiceAmount>(this.calculateBillingInvoiceAmountEndPoint, params)
                     .toPromise();
  }
}
